export default {
  CHIRURGIA: "web-chirurgia",
  MEDICINA: "web-medicina",
}
